import { Offer, OffersAndMetadata } from '@wwt/entities/search-response'

import { extractOfferFromOffers } from './extractOfferFromOffers'

export const extractOfferFromPages = (
	pages: OffersAndMetadata[],
	offerId: string | null
): Offer | null => {
	if (!pages) {
		return null
	}

	for (const page of pages) {
		const offer = extractOfferFromOffers(page.offers, offerId)

		if (offer) {
			return offer
		}
	}

	return null
}
